export default "__VITE_ASSET__DKb8uk_q__"